module.exports = __webpack_public_path__ + "img/rep-chelsea.2e94a116.png";